import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import CommonModal from '../../../../components/common-modal/CommonModal';

import scss from './ShareModal.module.scss';
import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import { Input } from '../../../../components/common-inputs';
import CopyButton from '../../../../components/copy-button/CopyButton';

const ShareModal = ({ isOpen, onClose, project }) => {
  const { t } = useTranslation('projects');
  const { link, projectPassword } = project || {};

  const handleCopyLink = useCallback(() => {
    navigator.clipboard.writeText(link);
  }, [link]);

  const handleCopyPassword = useCallback(() => {
    navigator.clipboard.writeText(projectPassword);
  }, [projectPassword]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <div className={scss.wrapper}>
        <h3 className={scss.title}>
          {t('share')}: <span className={scss.projectName}>{project.projectName}</span>
        </h3>

        <div className={scss.fields}>
          <WithLabel variant={LABEL_STYLES.CUSTOM} extraClassName={scss.fieldRow} label={t('link')} isBold>
            <div className={scss.fieldRowInput}>
              <Input type='text' size='sm' value={link} isReadOnly />
              <CopyButton onClick={handleCopyLink} disableTooltip />
            </div>
          </WithLabel>

          <WithLabel variant={LABEL_STYLES.CUSTOM} extraClassName={scss.fieldRow} label={t('password')} isBold>
            <div className={scss.fieldRowInput}>
              <Input type='text' size='sm' value={projectPassword} isReadOnly />
              <CopyButton onClick={handleCopyPassword} disableTooltip />
            </div>
          </WithLabel>
        </div>
      </div>
    </CommonModal>
  );
};

export default ShareModal;
